"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var FieldErrorShelf_1 = require("./FieldErrorShelf");
var RNFormShelf = /** @class */ (function () {
    function RNFormShelf(initialValues) {
        var _this = this;
        this.handleChange = function (field) { return function (value) {
            mobx_1.runInAction(function () {
                var _a;
                return _this.values = tslib_1.__assign(tslib_1.__assign({}, _this.values), (_a = {}, _a[field] = value, _a));
            });
        }; };
        this.field = function (field) { return ({
            name: field,
            onChangeText: _this.handleChange(field),
            value: _this.values[field],
            error: _this.fieldError.getFieldError(field),
        }); };
        this.getValues = function () { return _this.values; };
        this.getValue = function (field) { return (_this.values[field]); };
        this.values = initialValues;
        this.fieldError = new FieldErrorShelf_1.default();
        mobx_1.makeAutoObservable(this);
    }
    return RNFormShelf;
}());
exports.default = RNFormShelf;
